// extracted by mini-css-extract-plugin
module.exports = {"ValueText":"ValueText_ValueText__18Wwo","Property":"ValueText_Property__3uBtb","Value":"ValueText_Value__3QEiN"};